export default __webpack_public_path__ + "locales/es/ChangePortalOwner.json?hash=0c5bd3935fc7cfa39c53e264276abe2b";